"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fakeEmployees = exports.default = void 0;
var _TableBody2 = _interopRequireDefault(require("@mui/material/TableBody"));
var _react = _interopRequireDefault(require("react"));
var _environment = require("../../environment");
var _item = _interopRequireDefault(require("./item"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const fakeEmployees = exports.fakeEmployees = [{
  id: -1,
  username: 'Lycaon Doué',
  employee: null,
  profilePicture: null
}, {
  id: -1,
  username: 'Dromadaire Naturel',
  employee: null,
  profilePicture: null
}, {
  id: -1,
  username: 'Salamandre Diligente',
  employee: null,
  profilePicture: null
}, {
  id: -1,
  username: 'Licorne Efficace',
  employee: null,
  profilePicture: null
}];
function FakeItems(_ref) {
  let {
    Card,
    userType,
    challenge,
    subgroup,
    isCompany,
    leaderboard,
    displaySubgroups,
    displayType,
    sites,
    teams,
    subsidiaries,
    regions,
    exporting,
    disableContact,
    selectedUsers
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_TableBody2.default, {
    sx: {
      position: 'relative'
    }
  }, fakeEmployees.map((item, index) => /*#__PURE__*/_react.default.createElement(_item.default, {
    blurred: true,
    challenge: challenge,
    disableContact: disableContact,
    displaySubgroups: displaySubgroups,
    displayType: displayType,
    exporting: exporting,
    index: index,
    isCompany: isCompany,
    item: {
      ...item,
      progressValue: 0,
      rank: index + (displayType === 'individual' ? _environment.defaultEnvironment.freeOfferEmployeesLeaderboardsMaxRowsCount : _environment.defaultEnvironment.freeOfferSubgroupsLeaderboardsMaxRowsCount) + 1
    },
    key: index,
    leaderboard: leaderboard,
    regions: regions,
    selectedUsers: selectedUsers,
    sites: sites,
    subgroup: subgroup,
    subsidiaries: subsidiaries,
    teams: teams,
    userType: userType
  })), Card && /*#__PURE__*/_react.default.createElement(Card, null));
}
var _default = exports.default = FakeItems;